import React, { useEffect, useState } from 'react';
import InputField from '../../../../component/form/FormInput';
import Button from '../../../../component/ui/Button';
import { toast } from 'react-toastify';
import { formatErrors } from '../../../../utils/controller';
import { group__code_update } from '../../../../store/action/group';

const CreateGroupCodeModel = ({
	onCLose,
	reloadTable,
	groupCode,
	groupId,
	setGroupCode,
	shouldCallCalback = false,
}) => {
	const [error, setError] = useState('');
	const [loader, setLoader] = useState(false);
	const [code, setCode] = useState('');
	const [groupCodeDuplicateError, setGroupCodeDuplicateError] = useState(false);

	const submitForm = (event) => {
		event.preventDefault();

		if (code !== '' && code !== null && code !== undefined) {
			if (!code.trim()) {
				setError('Group name is required');
				return;
			}

			setLoader(true);
			setError('');
			let body = { code };
			group__code_update(groupId, body).then((res) => {
				if (res?.success) {
					setGroupCode(code);
					reloadTable();
					toast.success(res?.message);
					onCLose();
					setLoader(false);
				} else {
					formatErrors(res?.data?.message);
					toast.error(res?.response?.data?.message);
					setError(res?.response?.data?.message);
					setLoader(false);
				}
			});
		} else {
			setError('Please enter group code in the field');
		}
	};

	const getGroupCode = () => {
		setCode(groupCode);
	};

	useEffect(() => {
		getGroupCode();
	}, [groupCode]);

	return (
		<div>
			<form
				onSubmit={submitForm}
				className="add-productgroup-form"
			>
				<div
					className="d-flex align-items-center "
					style={{
						backgroundColor: '#E6F5FF',
						padding: '10px',
						marginBottom: '10px',
						borderRadius: '5px',
					}}
				>
					<div
						style={{
							color: '#000',
							fontSize: '15px',
							fontWeight: '600',
						}}
					>
						Note :{' '}
					</div>
					<div
						style={{
							color: '#434343',
							fontSize: '13px',
							fontWeight: '400',
						}}
					>
						{'Please create a unique group code for this group.'}
					</div>
				</div>
				<InputField
					label="Group Code"
					placeholder="Group code"
					type="text"
					required={true}
					name="group_code"
					autoFocus={true}
					onChange={(val) => {
						setCode(val);
						if (val !== '' && val !== undefined && val !== null) {
							setError();
						} else {
							setError('Please enter group code in the field');
						}
					}}
					value={code}
					error={error}
				/>
				<div className="add-productgroup-footer">
					<Button
						button="Save"
						className="btn-primary add-pgroup"
						loader={loader}
						onClick={submitForm}
					/>
					<Button
						type="button"
						button="Cancel"
						className="btn-dark add-pgroup"
						onClick={onCLose}
					/>
				</div>
			</form>
		</div>
	);
};

export default CreateGroupCodeModel;
